export const parseStepSearchParam = (stepParam: string | null) => {
  if (!stepParam || !/^\d+$/.test(stepParam)) {
    return 0;
  }

  return Number.parseInt(stepParam, 10);
};

export const isReloadNavigation = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const [navigationEntry] = window.performance.getEntriesByType('navigation');

  return (
    (navigationEntry as PerformanceNavigationTiming | undefined)?.type ===
    'reload'
  );
};

export const removeStepSearchParam = (searchParams: URLSearchParams) => {
  const nextParams = new URLSearchParams(searchParams);
  nextParams.delete('step');
  return nextParams;
};
